import { Box, Tooltip } from '@mui/material'
import React from 'react'

interface SentimentDisplayProps {
	value: number | null
	color: string
	label: string
}

/**
 * Display sentiment as a colored dot/box
 * Matches the old grid's TextAnalyticsSentimentControl display
 */
export const SentimentDisplay: React.FC<SentimentDisplayProps> = ({ value, color, label }) => {
	if (value === null) {
		return null
	}

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				width: '100%',
				height: '100%',
			}}
		>
			<Tooltip title={label}>
				<Box
					sx={{
						height: '14px',
						width: '14px',
						borderRadius: '4px',
						backgroundColor: color,
						flexShrink: 0,
					}}
				/>
			</Tooltip>
		</Box>
	)
}
